import React from 'react';
import { useTranslate } from 'react-admin';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';

import Chip from '@material-ui/core/Chip';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MuiMenuItem from '@material-ui/core/MenuItem';
import LockIcon from '@material-ui/icons/Lock';

import VeenguIcon from '~/components/VeenguIcon';
import { useStyles } from '~/hooks/useLayoutMenuStyles';
import { l, Badge } from '~/types/layoutMenu';
import { isPathMatch } from '~/utils/layoutMenu';

type FlyoutItemProps = {
  path: string;
  label: string;
  icon: JSX.Element;
  disabled?: boolean;
  badge?: Badge;
  onClose: () => void;
  exact?: boolean;
};

export const FlyoutItem = ({
  path,
  label,
  icon,
  disabled,
  badge,
  onClose,
  exact,
}: FlyoutItemProps) => {
  const history = useHistory();
  const location = useLocation();
  const translate = useTranslate();
  const t = (key: string, options?: any): string => translate(l(key), options);
  const classes = useStyles({});
  const isActive = isPathMatch(path, location.pathname, exact);

  return (
    <MuiMenuItem
      disabled={disabled}
      selected={isActive}
      className={classes.flyoutItem}
      component='a'
      href={path}
      onClick={(e: any) => {
        history.push(path);
        onClose();
        e.preventDefault();
      }}
    >
      <ListItemIcon className={classes.flyoutIcon}>{icon}</ListItemIcon>
      <ListItemText primary={t(label)} />
      {badge === 'notLicensed' && (
        <Chip
          size='small'
          icon={<VeenguIcon name='gem' style={{ fontSize: 12 }} />}
          label={t('addOn')}
          className={classes.notLicensedChip}
        />
      )}
      {badge === 'notAvailable' && (
        <LockIcon fontSize='small' className={classes.lockIcon} style={{ marginLeft: 8 }} />
      )}
      {badge === 'new' && <Chip size='small' label={t('new')} className={classes.newChip} />}
    </MuiMenuItem>
  );
};

export const FlyoutTitle = ({ children }: { children: React.ReactNode }) => {
  const classes = useStyles({});
  return <div className={classes.flyoutTitle}>{children}</div>;
};
